import Api from '../../api/index'

const Bill = {
  namespaced: true,
  state: {
    value: 'my value',

    oneBill: null, //to store SHOW response
    allBills: null, //to store SHOW response

    //promises results
    createBillWasGood: null,
    createBillMessage: null,
    
    updateBillWasGood: null,
    updateBillMessage: null,

     // less used
    indexBillWasGood: null,
    indexBillMessage: null,

    showBillWasGood: null,
    showBillMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneBill(state, Bill){
      state.oneBill = Bill // Bill.data
    },
    setAllBills(state, Bills){
      state.allBills = Bills // Bills.data
    },

    createResponse(state, {was_good, msg}){
      state.createBillWasGood = was_good
      state.createBillMessage = msg
      setTimeout(() => {
        state.createBillWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateBillWasGood = was_good
      state.updateBillMessage = msg
      setTimeout(() => {
        state.updateBillWasGood = null
      }, 230);
    },
    indexResponse(state, {was_good, msg}){
      state.indexBillWasGood = was_good
      state.indexBillMessage = msg
      setTimeout(() => {
        state.indexBillWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showBillWasGood = was_good
      state.showBillMessage = msg
      setTimeout(() => {
        state.showBillWasGood = null
      }, 100);
    },

    clearAllBills(state){
      state.allBills = null
    },
    clearOneBill(state){
      state.oneBill = null
    },
  },

  actions: {
    clearAllBills({commit}){
      commit('clearAllBills')
    },
    clearOneBill({commit}){
      commit('clearOneBill')
    },

    index(context, filter) {
      Api.Bill.index(filter)
        .then(response => response.data)
        .then(Bills => {
          context.commit('setAllBills', Bills);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    show(context, Bill_id) {
      Api.Bill.show(Bill_id)
        .then(response => response.data)
        .then(Bill => {
          context.commit('setOneBill', Bill);
          context.commit('showResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_Bill) {
      Api.Bill.create(new_Bill)
        .then(response => response.data)
        .then(Bill => {
          context.commit('setOneBill', Bill); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, Bill) {
      Api.Bill.update(Bill)
        .then(response => response.data)
        .then(Bill => {
          // context.commit('setOneBill', Bill); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
  }

};

export default Bill;